import {
    ICompany,
    IdName,
    IMessageData,
    IRouteDefinition,
    IRouteDefinitionParams
} from "../../../index";
import {DEFAULT_SMS_SENDER} from "../../../constants";
import * as ko from "knockout";
import {global} from "../../../appContext";
import {Toggle} from "../../../util/Toggle";
import {nsCustomerGeneral} from "./fn";
import {nsRoute} from "../../../util/route";
import {getObjectFromRouteData} from "../../../util/request";
import {getWebServiceUrl, isImportFormat, TImportFormatKey} from "../../../util/misc";
import {REQUEST_MESSAGE} from "../../../constants/Language";
import {SyncstepId} from "../../../constants/Syncstep";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import detailsHtml from './details.html?raw';

export let template: string = detailsHtml;

export class viewModel extends ParsedRouteDataDecorator {
    private readonly USERNAME_GENERATION_RULE_ID_FOR_EXPRESSION = nsCustomerGeneral.USERNAME_GENERATION_RULE_ID_FOR_EXPRESSION
    private readonly DEFAULT_SMS_SENDER = DEFAULT_SMS_SENDER;
    data: KnockoutObservable<ICompany | null> = ko.observable(null);
    availableStatuses: KnockoutObservableArray<IdName<number>> = ko.observableArray<IdName<number>>([]);

    toggle: { [key: string]: Toggle } = {
        apiaccess: new Toggle("toggle.customer.apiaccess", false)
    };

    private readonly req_getstatuscodes = global.getPromiseRequest('getstatuscodes');
    private readonly logLevel = nsCustomerGeneral.logLevel;
    private routeDef: IRouteDefinition;
    private readonly isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    private readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private readonly clientfiles: any;

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.routeDef = params.__routeDef!;
        this.initRequest();
        this.clientfiles = {
            orgnr: global.login.selectedOrganizationId(),
            token: global.login.getToken(),
            url: `${getWebServiceUrl('getclientfiles')}?rnd=${Math.random()}`,
        }
    }

    protected initRequest(): Promise<any> {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        return Promise.resolve()
            .then(() => this.__requestRouteData!
                .request()
                .then((data: any[]) => {
                    this.data(getObjectFromRouteData(data as [ICompany]));
                })
            )
            .then(() => this.req_getstatuscodes
                .request()
                .then((data: IdName[]) => {
                    this.availableStatuses(data);
                    this.messageData(null);
                    this.isReady(true);
                })
            )
    }

    statusMessage = ko.pureComputed((): IMessageData => {
        const data = this.data()!;
        return {
            message: data.status.name,
            type: data.status.id == 1 ? "info" : "warning"
        };
    });

    private is_importformathr = (...key: TImportFormatKey[]) => {
        return key.some(k => isImportFormat(k, this.data()!.importformathr));
    }

    private hasImportHR2Syncstep = ko.pureComputed((): boolean =>
        (this.data()?.syncsteps ?? []).some(step => step.syncstep.id === SyncstepId.ImportHR2)
    )

    override dispose() {
        super.dispose();
        this.req_getstatuscodes.abort()
    }

}
